import { render } from "./cambioContrasenia.vue?vue&type=template&id=c8fd457a&scoped=true"
import script from "./cambioContrasenia.vue?vue&type=script&lang=js"
export * from "./cambioContrasenia.vue?vue&type=script&lang=js"

import "./cambioContrasenia.vue?vue&type=style&index=0&id=c8fd457a&scoped=true&lang=css"
import "./cambioContrasenia.vue?vue&type=style&index=1&id=c8fd457a&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.41_vue@3.5.41_webpack@5.109.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8fd457a"]])

export default __exports__